module.exports = __webpack_public_path__ + "6a69f45d7c9ba9d9031eec1c87379bdd.png";